import VectorTile from 'ol/VectorTile';
import GeoJSON from 'ol/format/GeoJSON';
import { Auth } from '@shared/Auth';

async function vectorTileLoader(tile: VectorTile, url: string) {
    tile.setLoader(async () => {
        const token = await Auth.getToken();
        const resp = await fetch(url, {
            headers: { Authorization: 'Bearer ' + token.accessToken },
        });

        if (resp.ok) {
            const features = await resp.json();
            tile.setFeatures(
                GEOJSON_FORMAT.readFeatures(features, {
                    featureProjection: 'EPSG:3857',
                })
            );
        } else {
            tile.onError();
        }
    });
}

const GEOJSON_FORMAT = new GeoJSON({
    featureProjection: 'EPSG:3857',
});

async function imageTileLoader(imageTile, tileUrl) {
    const token = await Auth.getToken();

    const resp = await fetch(tileUrl, {
        headers: { Authorization: 'Bearer ' + token.accessToken },
    });

    if (resp.ok) {
        const blob = await resp.blob();
        const objectUrl = URL.createObjectURL(blob);

        imageTile.getImage().src = objectUrl;
        // Add custom headers
        imageTile.getImage().crossOrigin = 'anonymous';
    } else {
        imageTile.getImage().src = '';
    }
}

async function imageResponseTileLoader(imageTile, tileUrl) {
    const token = await Auth.getToken();

    const resp = await fetch(tileUrl, {
        headers: { Authorization: 'Bearer ' + token.accessToken },
    });

    if (resp.ok) {
        const responseJson = await resp.json();
        const objectUrl = responseJson.url;

        imageTile.getImage().src = objectUrl;
        // Add custom headers
        imageTile.getImage().crossOrigin = 'anonymous';
    } else {
        imageTile.getImage().src = '';
    }
}

export const DrawingLoaders = {
    imageTileLoader,
    imageResponseTileLoader,
    vectorTileLoader,
};
